'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrows-maximize';
var width = 448;
var height = 512;
var aliases = ["expand-arrows"];
var unicode = 'f31d';
var svgPathData = 'M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24L366.1 80 224 222.1 81.9 80 152 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56L0 184c0 13.3 10.7 24 24 24s24-10.7 24-24L48 113.9 190.1 256 48 398.1 48 328c0-13.3-10.7-24-24-24S0 314.7 0 328L0 456c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 432 224 289.9 366.1 432 296 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24L400 398.1 257.9 256 400 113.9 400 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24L296 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowsMaximize = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;